import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { Button } from "@mui/material";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import { companyFieldConfiguration } from "../../../formConfigs/Fleet/companyFieldConfig";

const UpdateCompanyPopup = ({ company }: { company: any }) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [initialValues, setInitialValues] = useState<any>(null);

  const queryClient = useQueryClient();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setInitialValues(null);
  };
  const handleSnackbarClose = () => setStatus("idle");

  const { token } = useAuth();

  useEffect(() => {
    if (open) {
      setInitialValues({
        id: company.realId,
        name: company.name,
        managerName: company.managerName,
        managerPhoneNumber: company.managerPhoneNumber,
        billingContactName: company.billingContactName,
        billingContactPhoneNumber: company.billingContactPhoneNumber,
        billingEmailAddress: company.billingContactEmail,
        defaultPaymentMethod: company.defaultPaymentMethod,
        taxId: company.taxId,
        dotNumber: company.dotNumber,
        mcNumber: company.mcNumber,
        addressLine1: company.addressLine1,
        addressLine2: company.addressLine2,
        city: company.city,
        state: company.state,
        zipCode: company.zipCode,
      });
    }
  }, [open]);

  const mutation = useMutation({
    mutationFn: (data: any) =>
      axios.put(`${apiVariable}/ownerCompany`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");

      queryClient.invalidateQueries({ queryKey: ["companies"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.message || "Failed to submit company");
    },
  });

  const submitHandler = (data: any) => {
    mutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Update
      </Button>
      {open && initialValues && (
        <GenericFormPopup
          formFields={companyFieldConfiguration}
          initialValues={initialValues}
          title="Update company"
          onSubmit={submitHandler}
          open={open}
          onClose={handleClose}
          loading={mutation.isPending}
        />
      )}

      <StatusSnackbar
        status={status}
        successMessage={"Company updated successfully"}
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default UpdateCompanyPopup;
